import { useState } from "react";
import "./style.css";

const FALLBACK_ITEMS = [];

export default function Faq({ faq, editMode, onError, onChange }) {
  const titulo = faq?.title ?? "Perguntas Frequentes";
  const items = editMode
    ? Array.isArray(faq?.items)
      ? faq.items
      : []
    : Array.isArray(faq?.items)
      ? faq.items
      : FALLBACK_ITEMS;
  // Guarda o indice da pergunta aberta; null = todas fechadas.
  const [abertoIndex, setAbertoIndex] = useState(null);

  const toggle = (i) => {
    setAbertoIndex((atual) => (atual === i ? null : i));
  };

  const handleItemChange = (index, field, value) => {
    const updatedItems = items.map((item, i) =>
      i === index ? { ...item, [field]: value } : item
    );
    onChange("items", updatedItems);
  };

  const handleAddItem = () => {
    onChange("items", [...items, { question: "", answer: "" }]);
    setAbertoIndex(items.length);
  };

  const handleRemoveItem = (index) => {
    const updatedItems = items.filter((_, i) => i !== index);
    onChange("items", updatedItems);
    setAbertoIndex((current) => {
      if (current === null) return null;
      if (current === index) return null;
      return current > index ? current - 1 : current;
    });
  };

  if (editMode) {
    return (
      <section className="faq">
        <input
          className="quem-somos-page-h2__input"
          value={titulo || ""}
          onChange={(e) => onChange("title", e.target.value)}
        />

        <div className="faq__lista">
          {items.map((item, i) => {
            const aberto = true;
            return (
              <div key={i} className="faq__item">
                <button
                  type="button"
                  className="faq__pergunta"
                  onClick={() => toggle(i)}
                  aria-expanded={aberto}
                >
                  <input style={{ marginBottom: "0px", background: "#234e9e", color: "#fff", border: "solid 2px #fff" }}
                    className="quem-somos-page-h2__input"
                    value={item.question || ""}
                    onChange={(e) => handleItemChange(i, "question", e.target.value)}
                  />
                  <svg
                    className={`faq__chevron ${aberto ? "faq__chevron--aberto" : ""}`}
                    width="28"
                    height="18"
                    viewBox="0 0 28 18"
                    fill="none"
                    aria-hidden="true"
                  >
                    <path
                      d="M12.5858 16.5858L1.41421 5.41421C0.154282 4.15428 1.04662 2 2.82843 2H25.1716C26.9534 2 27.8457 4.15428 26.5858 5.41421L15.4142 16.5858C14.6332 17.3668 13.3668 17.3668 12.5858 16.5858Z"
                      fill="white"
                    />
                  </svg>
                </button>

                {aberto && (
                  <div className="faq__resposta">
                    <textarea style={{ height: "100px", marginBottom: "0px" }}
                      className="quem-somos-page-p__textarea"
                      value={item.answer || ""}
                      onChange={(e) => handleItemChange(i, "answer", e.target.value)}
                    />
                  </div>
                )}
                <button
                  type="button"
                  className="faq__remover"
                  onClick={() => handleRemoveItem(i)}
                >
                  Remover pergunta
                </button>
              </div>
            );
          })}
        </div>

        <button
          type="button"
          className="faq__adicionar"
          onClick={handleAddItem}
        >
          + Adicionar pergunta
        </button>
      </section>
    );
  }

  return (
    <section className="faq">
      <h2 className="faq__titulo">{titulo}</h2>

      <div className="faq__lista">
        {items.map((item, i) => {
          const aberto = abertoIndex === i;
          return (
            <div key={i} className="faq__item">
              <button
                type="button"
                className="faq__pergunta"
                onClick={() => toggle(i)}
                aria-expanded={aberto}
              >
                <span>{item.question}</span>
                <svg
                  className={`faq__chevron ${aberto ? "faq__chevron--aberto" : ""}`}
                  width="28"
                  height="18"
                  viewBox="0 0 28 18"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M12.5858 16.5858L1.41421 5.41421C0.154282 4.15428 1.04662 2 2.82843 2H25.1716C26.9534 2 27.8457 4.15428 26.5858 5.41421L15.4142 16.5858C14.6332 17.3668 13.3668 17.3668 12.5858 16.5858Z"
                    fill="white"
                  />
                </svg>
              </button>

              {aberto && (
                <div className="faq__resposta">
                  <p>{item.answer}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
